import { GenericCollectionFactory } from ".";
import { BUDGETS_GENERIC_IDS } from "../_constants/generics.constants";

export const ProductsCollection = GenericCollectionFactory(BUDGETS_GENERIC_IDS.PRODUCTS, "uid");